import * as ng from 'angular';
import * as _ from 'underscore';
import {Moment} from 'moment';

import 'eonasdan-bootstrap-datetimepicker';

ng.module('e360')
   .directive('dateTimePicker', dateTimePickerDirective);

const templateUrl = require('./date-time-picker.directive.html');

export function dateTimePickerDirective() {
   return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
         disabled: '=?nvDisabled'
      },
      templateUrl: templateUrl,
      link: dateTimePickerLink
   };
}

function dateTimePickerLink(scope, element, attrs, ngModelCtrl:ng.INgModelController) {
   scope.format = attrs.format ? attrs.format : 'MM/DD/YYYY hh:mm A';

   // hold a variable for the setValue function for adding debounce
   let setValue = valueSetter;

   // optional timeout to avoid spamming server with requests
   if (attrs.timeout) {
      let timeout = parseInt(attrs.timeout);
      setValue = _.debounce(valueSetter, timeout);
   }

   // can't use this until angularjs is updated to 1.6 or greater
   // if (attrs.timeout) {
   //    ngModelCtrl.$overrideModelOptions({
   //       debounce: attrs.timeout
   //    });
   // }

   element.addClass('input-group');
   element.addClass('datetimepicker');
   if (scope.format === 'LT') {
      element.addClass('time-only');
   }

   element.datetimepicker({
      showClear: true,
      showClose: true,
      showTodayButton: true,
      allowInputToggle: true,
      useCurrent: false,
      widgetPositioning: {
         horizontal: 'auto',
         vertical: 'bottom'
      },
      format: scope.format
   });

   if (attrs.viewMode) {
      element.data('DateTimePicker').viewMode(attrs.viewMode);
   }

   if (attrs.placeholder) {
      element.find('input').attr('placeholder', attrs.placeholder);
   }

   let defaultTime:{hour:number,minute:number,second:number};
   if (attrs.defaultTime) {
      let digits = attrs.defaultTime.split(':');
      defaultTime = {
         hour: parseInt(digits[0]),
         minute: parseInt(digits[1]),
         second: parseInt(digits[2])
      };
   }

   ngModelCtrl.$formatters.push(onModelChange);
   element.on('dp.change', onDateChange);

   function onDateChange(e:{date:Moment, oldDate:Moment}) {
      if (e.oldDate === null && !ngModelCtrl.$modelValue) {
         if (defaultTime) {
            e.date.hour(defaultTime.hour);
            e.date.minute(defaultTime.minute);
            e.date.second(defaultTime.second);
         }

         element.data('DateTimePicker').date(e.date);
      }

      if (e.date) {
         setValue(e.date.format(scope.format));
      } else {
         setValue(null);
      }
   }

   function onModelChange(v:string) {
      if (v) {
         element.data('DateTimePicker').date(v);
      } else {
         element.data('DateTimePicker').clear();
      }
      return element.data('DateTimePicker').date();
   }

   function valueSetter(v:string) {
      ngModelCtrl.$setViewValue(v);
   }
}
